<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" lg="4" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <v-btn
              class="mx-1"
              color="primary"
              title="Registrar"
              small
              @click="$refs.modalFormularioAreaUniversidadRef.abrir(accionesCrud.REGISTRAR, [])">
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Editar"
              small
              :disabled="item == null"
              @click="$refs.modalFormularioAreaUniversidadRef.abrir(accionesCrud.EDITAR, item)">
              <v-icon>mdi-pencil</v-icon>

              Editar
            </v-btn>

            <v-btn
              small
              class="mx-1"
              :disabled="item == null"
              title="Eliminar"
              @click="() => confirmacionAccion(accionesAConfirmar.ELIMINAR, nombreItem, `${item.nombre}`)">
              <v-icon>mdi-close</v-icon>

              Eliminar
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoAreaUniversidad ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioAreaUniversidad
          ref="modalFormularioAreaUniversidadRef"
          :nombreRecurso="nombreItem"
          :universidadId="form.id"
          @actualizarListado="listar" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import ListadoAreaUniversidad from './ListadoAreaUniversidad.vue';
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import AreaUniversidadService from '../services/area-universidad.service';
import ModalFormularioAreaUniversidad from './ModalFormularioAreaUniversidad.vue';
import ListadoItem from './ListadoItem.vue';

export default {
  name: 'ModalAreaUniversidad',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoAreaUniversidad,
    ModalFormularioAreaUniversidad,
    ListadoItem,
  },
  data() {
    return {
      nombreItem: 'Área Universidad',
    };
  },
  computed: {
    listado() {
      return [
        { nombre: 'Nombre', valor: this.form.nombre },
        { nombre: 'Abreviatura', valor: this.form.abreviatura },
        { nombre: 'Tipo', valor: this.form.tipo },
        { nombre: 'Convenio', valor: this.form.convenio ? 'Si' : 'No' },
        { nombre: 'Código', valor: this.form.codigo ? this.form.codigo : '-' },
        { nombre: 'Estado', valor: this.form.estado ? 'Activo' : 'Inactivo' },
      ];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        estado: null,
        tipo: null,
        abreviatura: null,
        convenio: null,
        codigo: null,
        conceptosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        estado: data.estado,
        tipo: data.tipo,
        abreviatura: data.abreviatura,
        convenio: data.convenio,
        codigo: data.codigo,
        conceptosUniversidades: data.conceptosUniversidades,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        universidadId: this.form.id,
      };

      this.obtenerDatosConNotificacion(AreaUniversidadService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await AreaUniversidadService.remove(this.item.id);
      }

      return response;
    },
  },
};
</script>